module.exports = __webpack_public_path__ + "images/emoji/8ball.bb16a4f86cf3bb1614ff.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/8ball.png
// module id = wevs
// module chunks = 24